import {
  salaryRoutes,
  ticketRoutes,
  ExamRoutes,
  eventRoutes,
  authRoutes,
  tuitionFeeRoutes,
  creditRoutes,
  mealRoutes,
  teachingPlanRoutes,
  uniformRoutes
} from './compos'

const routes = [
  {
    path: '/',
    component: () => import('../components/layout/GuestLayout'),
    children: authRoutes
  },
  {
    path: '/',
    component: () => import('../components/layout/MainLayout'),
    meta: { title: 'Trang chủ' },
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/Dashboard.vue'),
        meta: {
          title: 'Bảng thông tin chung',
          auth: true
        }
      },
      {
        path: 'attendances',
        name: 'attendances',
        component: () => import('@/views/student/DiligenceTabs.vue'),
        meta: {
          title: 'Chuyên cần',
          auth: true,
          permission: 'view-attendance-item'
        }
      },
      {
        path: 'diligence',
        name: 'diligence',
        component: () => import('@/views/class/ClassDiligenceReport.vue'),
        meta: {
          title: 'Chuyên cần',
          auth: true,
          permission: 'view-attendance-item'
        }
      },
      {
        path: 'attendance/:id',
        name: 'attendance',
        component: () => import('@/views/attendance/Attendance'),
        meta: {
          title: 'Attendance',
          auth: true
        }
      },
      {
        path: 'schedule',
        name: 'schedule',
        component: () => import('@/views/schedule/Schedule.vue'),
        meta: {
          title: 'Thời Khóa Biểu',
          auth: true
        }
      },
      {
        path: 'subjectGroups',
        component: () => import('@/views/subjectGroup/SubjectGroups.vue'),
        name: 'SubjectGroups',
        meta: {
          title: 'Quản lý bộ môn',
          auth: true,
          permission: 'view-subjectGroup-list'
        }
      },
      {
        path: 'tuition-collection',
        component: () => import('@/views/tuitionFee/TuitionCollection.vue'),
        name: 'tuition-collection',
        meta: {
          title: 'Nhóm khoản phí',
          auth: true
        }
      },
      {
        path: 'academics',
        component: () => import('@/views/academicLevel/Academics.vue'),
        name: 'Academics',
        meta: {
          title: 'Quản lý cấp học',
          auth: true,
          permission: 'config-academic-level'
        }
      },
      {
        path: 'divisions',
        component: () => import('@/views/division/Divisions.vue'),
        name: 'Division',
        meta: {
          title: 'Phân ban',
          auth: true,
          permission: 'view-division-list'
        }
      },
      {
        path: 'classes',
        component: () => import('@/views/class/Classes'),
        name: 'Lớp Học',
        meta: {
          title: 'Quản lý lớp',
          auth: true,
          permission: 'view-class-list'
        }
      },
      {
        path: 'grades',
        component: () => import('@/views/grade/Grades.vue'),
        name: 'Grade',
        meta: {
          title: 'Quản lý khối',
          auth: true
        }
      },
      {
        path: 'subjects',
        component: () => import('@/views/subject/Subjects.vue'),
        name: 'Subjects',
        meta: {
          title: 'Môn Học',
          auth: true,
          permission: 'view-subject-list'
        }
      },
      {
        path: 'subject/:id',
        component: () => import('@/views/subject/Subject.vue'),
        name: 'Subject',
        meta: {
          title: 'Môn Học',
          auth: true
        }
      },
      {
        path: 'time-table-config',
        component: () => import('@/views/timetable/TimeTableConfig.vue'),
        name: 'timetable',
        meta: {
          title: 'Cấu Hình Thời Khóa Biểu',
          auth: true,
          permission: 'view-class-schedule'
        }
      },
      {
        path: 'time-table-conf1g',
        component: () => import('@/views/draftTimetable/OldT1metable.vue'),
        name: 'draftTimetable',
        meta: {
          title: 'Thời Khóa Biểu',
          auth: true
          // permission: 'view-class-schedule'
        }
      },
      {
        path: 'old-time-table',
        component: () => import('@/views/timetable/OldTimeTable.vue'),
        name: 'oldtimetable',
        meta: {
          title: 'Thời Khóa Biểu lưu',
          auth: true
          // permission: 'view-class-schedule'
        }
      },
      {
        path: 'complimented',
        component: () => import('@/views/violation/Violations.vue'),
        name: 'Violation',
        meta: {
          title: 'Khen thưởng kỷ luật',
          auth: true,
          permission: 'view-violation-list'
        }
      },
      {
        path: 'staffs',
        name: 'staffs',
        component: () => import('@/views/staff/Staffs'),
        props: { role: 'staffs' },
        meta: {
          title: 'Người dùng',
          auth: true,
          permission: 'view-staff-list'
        }
      },
      {
        path: 'staff/:id',
        name: 'staff',
        component: () => import('@/views/staff/Staff'),
        meta: {
          title: 'Người dùng',
          auth: true
        }
      },
      {
        path: 'teachers',
        name: 'teachers',
        component: () => import('@/views/teacher/Teachers'),
        props: { role: 'teacher' },
        meta: {
          title: 'Giáo Viên',
          auth: true,
          permission: 'view-teacher-list'
        }
      },
      {
        path: 'teaching',
        name: 'teaching',
        component: () => import('@/views/teacher/Teaching'),
        props: { role: 'teacher' },
        meta: {
          title: 'Giảng dạy',
          auth: true,
          permission: 'view-teaching-list'
        }
      },
      {
        path: 'ownClassTeacher',
        name: 'ownClassTeacher',
        component: () => import('@/views/teacher/OwnClassTeacher'),
        props: { role: 'teacher' },
        meta: {
          title: 'Chủ nhiệm',
          auth: true,
          permission: 'view-ownClass-list'
        }
      },
      {
        path: 'teacher-dashboard',
        name: 'TeacherDashboard',
        component: () => import('@/views/teacherSideViews/Dashboard'),
        meta: {
          title: 'Dashboard',
          auth: true
        }
      },
      {
        path: 'ownClassTimeTable',
        name: 'ownClassTimeTable',
        component: () => import('@/views/teacherSideViews/OwnClassTimeTable.vue'),
        meta: {
          title: 'Thời khóa biểu',
          auth: true
        }
      },
      {
        path: 'teachingTimeTable',
        name: 'teachingTimeTable',
        component: () => import('@/views/teacherSideViews/TeachingTimeTable.vue'),
        meta: {
          title: 'Thời khóa biểu',
          auth: true
        }
      },
      {
        path: '/teacher-classes',
        name: 'TeacherClasses',
        component: () => import('@/views/teacher/Classes'),
        meta: {
          title: 'Danh Sách Lớp Của Tôi',
          auth: true
        }
      },
      {
        path: '/teacher-attendance',
        name: 'TeacherAttendance',
        component: () => import('@/views/teacher/Attendances'),
        meta: {
          title: 'Điểm Danh Của Tôi',
          auth: true
        }
      },
      {
        path: 'teacher/:id',
        name: 'teacher',
        component: () => import('@/views/teacher/Teacher'),
        meta: {
          title: 'Giáo viên',
          auth: true
        }
      },
      {
        path: 'students',
        name: 'students',
        component: () => import('@/views/student/Students'),
        props: { role: 'student' },
        meta: {
          title: 'Danh sách học sinh',
          auth: true,
          permission: 'view-student-list'
        }
      },
      {
        path: 'reservation',
        name: 'Reservation',
        component: () => import('@/views/student/Reservation.vue'),
        props: { role: 'student' },
        meta: {
          title: 'Quản lý bảo lưu',
          auth: true
        }
      },
      {
        path: 'student/:id',
        name: 'studentInfor',
        component: () => import('@/views/student/Student'),
        props: { role: 'student' },
        meta: {
          title: 'Học sinh',
          auth: true
        }
      },
      {
        path: 'student-import',
        name: 'studentImport',
        component: () => import('@/views/student/StudentImporter.vue'),
        props: { role: 'student' },
        meta: {
          title: 'Student Importer',
          auth: true
        }
      },
      {
        path: 'bus/:id',
        name: 'bus',
        component: () => import('@/views/bus/BusDetail'),
        meta: {
          title: 'Tuyến xe',
          auth: true
        }
      },
      {
        path: 'class/:id',
        name: 'class',
        component: () => import('@/views/class/ClassDetail'),
        meta: {
          title: 'Lớp học',
          auth: true
        }
      },
      {
        path: 'class/mark/:id',
        name: 'class-mark',
        component: () => import('@/views/class/ClassMark'),
        meta: {
          title: 'Điểm số',
          auth: true
        }
      },
      {
        path: 'absent-request',
        name: 'absent-request',
        component: () => import('@/views/absent-request/AbsentRequest.vue'),
        meta: {
          title: 'Báo nghỉ',
          auth: true
        }
      },
      {
        path: 'class/schedule/:id',
        name: 'class-slot',
        component: () => import('@/views/class/ClassSlots'),
        meta: {
          title: 'Điểm danh',
          auth: true
        }
      },
      {
        path: 'marks-input',
        name: 'Nhập điểm',
        component: () => import('@/views/mark/InputMarks.vue'),
        meta: {
          title: 'Nhập điểm',
          auth: true,
          permission: 'update-class-mark'
        }
      },
      {
        path: 'marks',
        name: 'Sổ điểm học sinh',
        component: () => import('@/views/mark/Marks.vue'),
        meta: {
          title: 'Sổ điểm',
          auth: true,
          permission: 'view-class-mark'
        }
      },
      {
        path: 'student-mark',
        name: 'Sổ điểm',
        component: () => import('@/views/student/StudentMarks.vue'),
        meta: {
          title: 'Sổ điểm học sinh',
          auth: true,
          permission: 'view-student-mark'
        }
      },
      {
        path: 'contact-book',
        name: 'Sổ liên lạc',
        component: () => import('@/views/account/ContactBooks.vue'),
        meta: {
          title: 'Danh sách sổ liên lạc',
          auth: true,
          permission: 'view-contactBook-list'
        }
      },
      {
        path: 'contact-book-detail/:id',
        name: 'Danh sách sổ liên lạc',
        component: () => import('@/modules/contactBook/StudentContactBookDetail.vue'),
        meta: {
          title: 'Chi tiết tin đã gửi',
          auth: true
        }
      },
      {
        path: 'post-send',
        name: 'Gửi tin nhắn',
        component: () => import('@/views/post/PostCreate.vue'),
        meta: {
          title: 'Gửi tin nhắn',
          auth: true,
          permission: 'send-noti-immediately'
        }
      },
      {
        path: 'post-send-auto',
        name: 'Gửi tin tự động',
        component: () => import('@/views/post/PostCreateAuto.vue'),
        meta: {
          title: 'Gửi tin tự động',
          auth: true,
          permission: 'send-noti-daily'
        }
      },
      {
        path: 'post-history',
        name: 'Lịch sử gửi tin',
        component: () => import('@/views/post/PostCreateHistory.vue'),
        meta: {
          title: 'Lịch sử gửi tin',
          auth: true,
          permission: 'view-noti-history'
        }
      },
      {
        path: 'settings',
        name: 'Cài đặt',
        component: () => import('@/views/setting/ConfigRole.vue'),
        meta: {
          title: 'Cài đặt quyền truy cập',
          auth: true,
          permission: 'config-roles'
        }
      },
      {
        path: '/feedback',
        component: () => import('@/views/feedback/Feedback.vue'),
        name: 'feedback',
        meta: {
          title: 'Phản hồi',
          auth: true,
          permission: 'view-feedback-group'
        }
      },
      {
        path: '/feedback/:id',
        component: () => import('@/views/feedback/Feedback.vue'),
        name: 'feedbackDetail',
        meta: {
          title: 'Phản hồi',
          auth: true,
          permission: 'view-feedback-group'
        }
      },
      {
        path: '/teacher-feedback',
        component: () => import('@/views/feedback/TeacherFeedback.vue'),
        name: 'teacherFeedback',
        meta: {
          title: 'Phản hồi GVCN',
          auth: true
          // permission: ''
        }
      },
      {
        path: '/teacher-feedback/:id',
        component: () => import('@/views/feedback/TeacherFeedback.vue'),
        name: 'teacherFeedbackDetail',
        meta: {
          title: 'Phản hồi GVCN',
          auth: true
          // permission: ''
        }
      },
      {
        path: '/teacherDocumentTypes',
        component: () => import('@/views/document/TeacherDocumentTypes.vue'),
        name: 'teacherDocumentTypes',
        meta: {
          title: 'Sổ sách cá nhân của GV',
          auth: true
          // permission: ''
        }
      },
      {
        path: '/teacher-document/:id',
        component: () => import('@/views/document/TeacherDocuments.vue'),
        name: 'teacherDocumentList',
        meta: {
          title: 'Sổ sách cá nhân của GV',
          auth: true
          // permission: ''
        }
      },
      {
        path: '/directiveDocumentTypes',
        component: () => import('@/views/document/DirectiveDocumentTypes.vue'),
        name: 'directiveDocumentTypes',
        meta: {
          title: 'Văn bản chỉ đạo',
          auth: true
          // permission: ''
        }
      },
      {
        path: '/directive-document/:id',
        component: () => import('@/views/document/DirectiveDocuments.vue'),
        name: 'directiveDocumentList',
        meta: {
          title: 'Văn bản chỉ đạo',
          auth: true
          // permission: ''
        }
      },
      {
        path: '/schoolSchedule',
        component: () => import('@/views/document/SchoolSchedule.vue'),
        name: 'SchoolSchedule',
        meta: {
          title: 'KH năm học + KHGD nhà trường',
          auth: true
          // permission: ''
        }
      },
      {
        path: '/managerDocumentTypes',
        component: () => import('@/views/managerDocument/ManagerDocumentTypes.vue'),
        name: 'managerDocumentTypes',
        meta: {
          title: 'Hồ sơ Ban Giám Hiệu',
          auth: true
          // permission: ''
        }
      },
      {
        path: '/teachingDoc',
        component: () => import('@/views/teacherDocAdmin/TeachingCatPage.vue'),
        name: 'teachingDoc',
        meta: {
          title: 'Sổ sách giảng dạy',
          auth: true
          // permission: ''
        }
      },
      {
        path: '/classDoc/',
        component: () => import('@/views/teacherDocAdmin/ClassCatPage.vue'),
        name: 'teacherOwnClassCat',
        meta: {
          title: 'Sổ sách chủ nhiệm',
          auth: true
          // permission: ''
        }
      },
      // here to find teacherDocCatRoute
      {
        path: '/teachingDoc',
        component: () => import('@/views/teacherDocAdmin/teachingLevel.vue'),
        name: 'teachingDoc',
        meta: {
          title: 'Sổ sách',
          auth: true
          // permission: ''
        }
      },
      {
        path: '/teacherDoc/:level/teacherCat',
        component: () => import('@/views/teacherDoc/teacherCat.vue'),
        name: 'teacherCat',
        meta: {
          title: 'Sổ sách',
          auth: true
          // permission: ''
        }
      },
      {
        path: '/teacherDoc',
        component: () => import('@/views/teacherDoc/TeacherCatPage.vue'),
        name: 'teacherDoc',
        meta: {
          title: 'Sổ sách',
          auth: true
          // permission: ''
        }
      },
      {
        path: '/teachingDoc/:level/teachingCat/',
        component: () => import('@/views/teacherDocAdmin/teachingCat.vue'),
        name: 'teachingCat',
        meta: {
          title: 'Sổ sách',
          auth: true
          // permission: ''
        }
      },
      {
        path: '/teachingDoc/:level/teacherOwnClassCat/',
        component: () => import('@/views/teacherDocAdmin/ownClassCat.vue'),
        name: 'teacherOwnClassCat',
        meta: {
          title: 'Sổ sách',
          auth: true
          // permission: ''
        }
      },

      {
        path: '/task-manager',
        component: () => import('@/views/taskManager/TaskManager.vue'),
        name: 'task-manager',
        meta: {
          title: 'Giao nhận việc',
          auth: true,
          permission: 'task-manage-access'
        }
      },
      {
        path: '/busList',
        component: () => import('@/views/bus/BusList.vue'),
        name: 'busList',
        meta: {
          title: 'Danh sách xe tuyến',
          auth: true
          // permission: ''
        }
      },
      {
        path: '/studentBusList',
        component: () => import('@/views/bus/StudentBusList.vue'),
        name: 'studentBusList',
        meta: {
          title: 'Danh sách học sinh xe tuyến',
          auth: true
          // permission: ''
        }
      },
      {
        path: '/busStudentAttendance',
        component: () => import('@/views/bus/BusStudentAttendance.vue'),
        name: 'busStudentAttendance',
        meta: {
          title: 'Chi tiết học sinh xe tuyến',
          auth: true
        }
      },
      {
        path: '/busCheckin',
        component: () => import('@/views/bus/BusCheckin.vue'),
        name: 'busCheckin',
        meta: {
          title: 'Báo cáo tình trạng xe tuyến',
          auth: true
        }
      },
      {
        path: '/bus-checkin-detail/:busCheckInId',
        component: () => import('@/views/bus/BusCheckinDetail.vue'),
        name: 'busCheckinDetail',
        meta: {
          title: 'Báo cáo tình trạng xe tuyến',
          auth: true
        }
      },
      {
        path: '/manager-document/:id/:year',
        component: () => import('@/views/managerDocument/ManagerDocuments.vue'),
        name: 'managerDocuments',
        meta: {
          title: 'Hồ sơ Ban Giám Hiệu',
          auth: true
        }
      },
      // {
      //   path: '/classNote',
      //   component: () => import('@/views/classNote/ClassNote.vue'),
      //   name: 'ClassNote',
      //   meta: {
      //     title: 'Sổ ghi đầu bài',
      //     auth: true
      //     // permission: ''
      //   }
      // },
      {
        path: '/teacherClassNotes',
        component: () => import('@/views/teacher/ClassNotes.vue'),
        name: 'teacherClassNotes',
        meta: {
          title: 'Sổ ghi đầu bài'
        }
      },

      {
        path: '/teachingReport',
        component: () => import('@/views/teachingReport/TeachingReport.vue'),
        name: 'teachingReport',
        meta: {
          title: 'Sổ ghi đầu bài'
        }
      },

      {
        path: '/classNoteDetail/:id/:date',
        component: () => import('@/views/teacher/ClassNoteDetail.vue'),
        name: 'classNoteDetail',
        meta: {
          title: 'Sổ ghi đầu bài'
        }
      },

      {
        path: '/integration',
        component: () => import('@/views/integrations/Integrations.vue'),
        name: 'intergration',
        meta: {
          title: 'Tích hợp'
        }
      },

      {
        path: '/class-note-bot',
        component: () => import('@/views/others/FillClassNoteBot.vue'),
        name: 'class-note-bot',
        meta: {
          title: 'class-note-bot',
          auth: true
        }
      },

      {
        path: '/teacher-class-report',
        component: () => import('@/views/teacher/TeacherClassReport.vue'),
        name: 'teacher-class-report',
        meta: {
          title: 'Báo cáo tiết dạy',
          auth: true
        }
      },
      {
        path: '/teacher-class-report/:id/:date',
        component: () => import('@/views/teacher/TeacherClassReportDetail.vue'),
        name: 'teacher-class-report-detail',
        meta: {
          title: 'Chi tiết báo cáo tiết dạy',
          auth: true
        }
      },
      {
        path: '/student-credit',
        component: () => import('@/views/studentCredit'),
        name: 'student-credit',
        meta: {
          title: 'Quản lý quỹ xu',
          auth: true
        }
      },
      {
        path: '/student-credit/:id',
        component: () => import('@/views/studentCredit/StudentCreditDetail.vue'),
        name: 'student-credit-detail',
        meta: {
          title: 'chi tiết quỹ xu',
          auth: true
        }
      },
      {
        path: '/student-credit-report',
        component: () => import('@/views/studentCreditReport'),
        name: 'student-credit-report',
        meta: {
          title: 'Báo cáo quỹ xu',
          auth: true
        }
      },
      {
        path: '/add-coin-manager',
        component: () => import('@/views/add-coin-manager/index.vue'),
        name: 'add-coin-manager',
        meta: {
          title: 'Quản lý nạp xu',
          auth: true
        }
      },
      {
        path: '/survey',
        component: () => import('@/views/survey/survey/index.vue'),
        name: 'survey',
        meta: {
          title: 'Khảo sát',
          auth: true
        }
      },
      {
        path: '/survey-detail/:id',
        component: () => import('@/views/survey/detail-survey/index.vue'),
        name: 'survey-detail',
        meta: {
          title: 'Chi tiết khảo sát',
          auth: true
        }
      },
      {
        path: '/school-bank-account',
        component: () => import('@/views/school-bank-account/index.vue'),
        name: 'school-bank-account',
        meta: {
          title: 'Tài khoản học phí',
          auth: true
        }
      },
      {
        path: '/club',
        component: () => import('@/views/club/Club.vue'),
        name: 'club',
        meta: {
          title: 'Câu lạc bộ',
          auth: true
        }
      },
      {
        path: '/club-detail/:id',
        component: () => import('@/views/club/ClubDetail.vue'),
        name: 'club-detail',
        meta: {
          title: 'Chi tiết câu lạc bộ',
          auth: true
        }
      },
      {
        path: '/teacherPostCreate',
        component: () => import('@/views/teacher/TeacherPostCreate.vue'),
        name: 'teacherPostCreate',
        meta: {
          title: 'Gửi tin nhắn'
        }
      },


      ...mealRoutes,
      ...creditRoutes,
      ...tuitionFeeRoutes,
      ...salaryRoutes,
      ...ticketRoutes,
      ...ExamRoutes,
      ...eventRoutes,
      ...uniformRoutes,
      ...teachingPlanRoutes,
      {
        path: '*',
        name: 'page404',
        component: () => import('@/views/Page404'),
        meta: {
          title: 'Page not found'
        }
      }
    ]
  }
]
export default routes
